module.exports = __webpack_public_path__ + "img/all.6ced169b.svg";